import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';

import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

import * as myConstClass from '../../shared/constants/constants';

const DASHMOD_NBOF_DATACOL = 10;
const PAGER_DISPPAGES = 4;
const PAGER_PAGESIZE = 10;

class DashMod_GameResultsPlayerComp01 extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			playerId: '0',
			resultsType: '',
			leagueType: '',

			resultTableData1: [],
			sortFieldIdx1: 3,
			sortOrder1: 'desc',	// vic desc by default
			sortClass1: [],
			minGamesPlayed: 1,
			filtLoading: false,

			pager: {
				startIndex: 0,
				totalPages: 1,
				pages: [1],
				currentPage: 1,
				pageSize: PAGER_PAGESIZE,
				endIndex: PAGER_PAGESIZE - 1,
				totalItems: 0
			},

			opponentsIds: ['0', '0', '0', '0'],
/*
			opponentsIds: [
				'5854500315f60d187fbf9efe',
				'593605225882c72f70bc6baf',
				'5808e2c2569e3c78147911c3',
				'5854502215f60d187fbf9f00',
			],
*/
			resultTableData2: [],
			sortFieldIdx2: 3,
			sortOrder2: 'desc',	// date desc by default
			sortClass2: [],

			showTVs: false,
			loading: true
		};
	
		this.createTableRow1 = this.createTableRow1.bind(this);
		this.createTableRow2 = this.createTableRow2.bind(this);
		this.createTableCell2 = this.createTableCell2.bind(this);

		this.handleSortTable1 = this.handleSortTable1.bind(this);
		this.handleSortTable2 = this.handleSortTable2.bind(this);
		this.handlePlayerChange1 = this.handlePlayerChange1.bind(this);
		this.handlePlayerChange2 = this.handlePlayerChange2.bind(this);
		this.handlePlayerChange3 = this.handlePlayerChange3.bind(this);
		this.handlePlayerChange4 = this.handlePlayerChange4.bind(this);
		this.handleMinGamesPlayed = this.handleMinGamesPlayed.bind(this);
		this.handlePlayerOnBlur1 = this.handlePlayerOnBlur1.bind(this);

		this.handleApplyFilter = this.handleApplyFilter.bind(this);
		this.handleRemoveFilter = this.handleRemoveFilter.bind(this);
	}

	componentDidMount() {
    // console.log('DashMod: componentDidMount');
		var playerId = this.props.playerId; 
    var resultsType = this.props.resultsType;
    var leagueType = this.props.leagueType;

		this.initiatePagerSizeWithData(playerId, resultsType, leagueType, this.state.minGamesPlayed, true);
		this.loadData2(-1, null, playerId, resultsType, leagueType);
	}

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('DashMod: UNSAFE_componentWillReceiveProps');
    var playerId = nextProps.playerId;
    var resultsType = nextProps.resultsType;
    var leagueType = nextProps.leagueType;

		this.initiatePagerSizeWithData(playerId, resultsType, leagueType, this.state.minGamesPlayed, true);
		this.loadData2(-1, null, playerId, resultsType, leagueType);
  }

	initiatePagerSizeWithData(playerId, resultsType, leagueType, minGamesPlayed, loading) {
		var _this = this;
		var sortClass1 = [];
		for(var i = 1; i < (DASHMOD_NBOF_DATACOL - 1); i++) {
			sortClass1[i] = '';
		}
		sortClass1[this.state.sortFieldIdx1] = "statelo-sorting_" + this.state.sortOrder1;

		var sortClass2 = [];
		for(var i = 1; i < (DASHMOD_NBOF_DATACOL - 1); i++) {
			sortClass2[i] = '';
		}
		sortClass2[this.state.sortFieldIdx2] = "statelo-sorting_" + this.state.sortOrder2;

		var showTVs = true;
		if (leagueType === myConstClass.LGTYPE_10B) {
			showTVs = false;
		}

		if (minGamesPlayed < 1) {
			minGamesPlayed = 1;
		}

		this.setState({
      playerId: playerId,
      resultsType: resultsType,
      leagueType: leagueType,
      minGamesPlayed: minGamesPlayed,
      showTVs: showTVs,
      sortClass1: sortClass1,
      sortClass2: sortClass2,
      loading: loading,
		});

		Axios.get('/api/dashmod/gameResultsCompiled/size/playerId/' + playerId + 
				  '/resultsType/' + resultsType + '/leagueType/' + leagueType +
				  '/minGP/' + minGamesPlayed).then(function(response) {
			
				// Init pager
				var pager = {
					totalPages: 1,
					pages: [1],
					currentPage: 1,
					pageSize: PAGER_PAGESIZE,
					startindex: 0,
					endIndex: PAGER_PAGESIZE-1,
					totalItems: response.data.count,
				};
				_this.setPage(1, pager);
			});
	}

  setPage(page, pager) {
  	// set optional parameters
    var pager = pager || this.state.pager;
    if (page < 1 || page > pager.totalPages) {
    	console.log('************ ERR *************');
    	console.log('setPage unexpected return');
    	return;
    }

    // get new pager object for specified page
    pager = this.getPager(pager.totalItems, page);

    // call change page function in parent component
    this.loadData1(pager, this.state.sortFieldIdx1, this.state.sortOrder1);
  }

  getPager(totalItems, currentPage, pageSize) {
    // default to first page
    currentPage = currentPage || 1;

    // default page size is 10
    pageSize = pageSize || PAGER_PAGESIZE;

    // calculate total pages
    var totalPages = Math.ceil(totalItems / pageSize);

    var startPage, endPage;
    if (totalPages <= PAGER_DISPPAGES) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= ((PAGER_DISPPAGES / 2) + 1)) {
        startPage = 1;
        endPage = PAGER_DISPPAGES;
      } else if (currentPage + ((PAGER_DISPPAGES / 2) - 1) >= totalPages) {
        startPage = totalPages - (PAGER_DISPPAGES - 1);
        endPage = totalPages;
      } else {
        startPage = currentPage - Math.ceil(PAGER_DISPPAGES / 2);
        endPage = currentPage + Math.ceil((PAGER_DISPPAGES / 2) - 1);
      }
    }

    // calculate start and end item indexes
    var startIndex = (currentPage - 1) * pageSize;
    var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    // var pages = _.range(startPage, endPage + 1);		// lodash function
 		var pages = Array.apply(0, Array(endPage - startPage + 1)).map(function (element, index) { 
    	return index + startPage;  
  	});
    
    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    };
  }

	loadData1(pager, sortFieldIdx1, sortOrder1) {
		var _this = this;
		Axios.get('/api/dashmod/gameResultsCompiled/playerId/' + this.state.playerId + 
			'/oppids/' + '-1' + 
			'/resultsType/' + this.state.resultsType + '/leagueType/' + this.state.leagueType +
			'/start/' + pager.startIndex + '/end/' + (pager.endIndex + 1) + 
			'/sortFieldIdx/' + sortFieldIdx1 + '/sortOrder/' + sortOrder1 + '/minGP/' + this.state.minGamesPlayed).
			then(function(response) {

				// console.log(response.data);
				_this.setState({
					pager: pager,
					resultTableData1: response.data,
					loading: false,
					filtLoading: false
				});
		});
	}

	loadData2(oppNo, oppId, playerId, resultsType, leagueType) {
		var _this = this;
		var opponentsIds = this.state.opponentsIds;

		// Initial load or change of oppId
		if (oppNo !== -1) {
			opponentsIds[oppNo] = oppId;
		}
		var opponentsIdsStr = opponentsIds.join();

		// Load data
		if(playerId !== '0') {
			Axios.get('/api/dashmod/gameResultsCompiled/playerId/' + playerId + 
				'/oppids/' + opponentsIdsStr +
				'/resultsType/' + resultsType + '/leagueType/' + leagueType +
				'/start/-1/end/-1' + '/sortFieldIdx/' + '2' + '/sortOrder/' + 'desc' + '/minGP/-1').
				then(function(response) {

					var dataResults = response.data;
					var tableResults = [];

					// Build results
					dataResults.forEach(function(result) {
						tableResults.push([
							result.player1name,
							result.player2name,
							result.gamesPlayed,
							result.wins,
							result.losts,
							result.nbEroPour,
							result.nbEroContre,
							result.nbTvPour,
							result.nbTvContre,
							result.winPct
						])
					});
					_this.sortData2(tableResults, _this.state.sortFieldIdx2, _this.state.sortOrder2);
			});	
		}
	}

	sortData2(data, sortFieldIdx, sortOrder) {
		var sortSign = 1;
		if (sortOrder === 'desc') { 
			sortSign = -1; 
		}

		data.sort(function(a, b) {

			var valueA = a[sortFieldIdx];
			var valueB = b[sortFieldIdx];
			var compVal = 0;

			switch(typeof a[sortFieldIdx]) {
			    case "date":
					compVal = new Date(valueA) - new Date(valueB);
			        break;
			    case "string":
					compVal = valueA.localeCompare(valueB);
			        break;
			    case "number":
					compVal = valueA - valueB;
			        break;
			    default:
			        break;
			}

			if (compVal !== 0) return (sortSign * compVal);
			return (a[0] - b[0]);
		});
	
		this.setState({
			resultTableData2: data,
			sortFieldIdx2: sortFieldIdx,
			sortOrder2: sortOrder,
		});
	}

	render() {
/*
		console.log('DashMod_GameResultsPlayerComp01: render');
		console.log(this.state.resultTableData1);
		console.log(this.state.resultTableData2);
*/
    var pager = this.state.pager;
		return (
			<div className="row db-module-outer-dark">
			<div className="col-12">

				<div className="row">
				<div className="col-12 text-center">
					<h4 className="db-module-title-dark">Vos affrontements</h4>
				</div>
				</div>

				<div className="row db-module-inner-dark">
				<div className="col-md-12 db-module-inner-col-padding">
				<div className="card db-module-inner-card-dark">

				{this.state.loading ? 
					<div className="text-center"> 
						<i> données en chargement </i>
						{this.displaySpinner()}
					</div> 
					: this.dispModules(pager)}

				</div>
				</div>
				</div>
			</div>
			</div>
		)
	}

	dispModules(pager) {
		var bDispModule = true;
		var bDispPagination = true;

    if (pager.pages.length < 1) {
    	bDispModule = false;
    } 
    if (pager.pages.length < 2) {
			bDispPagination = false;
		}

		return (
			<div>
		  	<div className="row">
				<div className="col-md-8">
					<span><b>Tous les affrontements</b></span><br/>
				</div>
				</div>

		  	<div className="row db-menu-item db-menu-padright">
					<span className="db-menu-item db-menu-nopad">Minimum de parties jouées (PJ)</span>

					<input className="form-control form-control-sm input-sm form-control-flexiblewidth width75px db-menu-item db-menu-padsides" 
						type="number" id="minGames" value={this.state.minGamesPlayed || ""} onChange={this.handleMinGamesPlayed} />

					<button className="btn btn-primary btn-sm2 db-menu-item db-menu-padsides"
						onClick={this.handleApplyFilter} value="Appliquer"> Filtrer </button>

					<button className="btn btn-primary btn-sm2 db-menu-item db-menu-padsides"
						onClick={this.handleRemoveFilter} value="Appliquer"> Retirer le filtre </button>

					{this.state.filtLoading ? 
						this.displaySpinnerNoMargin()
						: null}
    		</div>

	    	<div className="row db-menu-item db-menu-padright">
					<span>{pager.totalItems} adversaires</span><br/>
				</div>

				{this.displayData1(pager)}
				{bDispPagination ? this.displayPagination(pager) : null}
				<hr/>
				{this.displayData2()}
			</div>
		)
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	displaySpinnerNoMargin() {
		return (
  		<div className="sk-three-bounce sk-three-bounce-no-margin">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	displayData1(pager) {
		var sortClass = this.state.sortClass1;
		var nameCellWidthPx = "200px";
		if (this.state.leagueType === myConstClass.LGTYPE_10B) {
			nameCellWidthPx = "300px";
		}

		return (
			<div>
			<div className="table-responsive">
			<table className="table table-striped table-hover table-sm">
			<thead>
				<tr>
				<th id="colid.0" className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable1} width={nameCellWidthPx}> Joueur(s) </th>
				<th id="colid.1" className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable1} width={nameCellWidthPx}> Adversaire(s) </th>
				<th id="colid.2" className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable1}> PJ </th>
				<th id="colid.3" className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable1}> VIC </th>
				<th id="colid.4" className={"statelo-sorting " + sortClass[4]} onClick={this.handleSortTable1}> DEF </th>

				<th id="colid.5" className={"statelo-sorting " + sortClass[5]} onClick={this.handleSortTable1}> EP </th>
				<th id="colid.6" className={"statelo-sorting " + sortClass[6]} onClick={this.handleSortTable1}> EC </th>
				{this.state.showTVs ? <th id="colid.7" className={"statelo-sorting " + sortClass[7]} onClick={this.handleSortTable1}> TVP </th> : null}
				{this.state.showTVs ? <th id="colid.8" className={"statelo-sorting " + sortClass[8]} onClick={this.handleSortTable1}> TVC </th> : null}

				<th id="colid.9" className={"statelo-sorting " + sortClass[9]} onClick={this.handleSortTable1}> % VIC </th>
				</tr>
			</thead>

			<tbody>
				{(this.state.resultTableData1.length > 0) ? 
					this.state.resultTableData1.map(this.createTableRow1) :
					this.dispNoResults() 
				}
			</tbody>
			</table>

			</div>
			</div>
		);
	}

	displayData2() {
		var sortClass = this.state.sortClass2;
		var nameCellWidthPx = "200px";
		if (this.state.leagueType === myConstClass.LGTYPE_10B) {
			nameCellWidthPx = "300px";
		}

		return (
			<div>
    	<div className="row">
				<div className="col-md-12">
					<span><b>Trouver des adversaires</b><br/></span>
					<span><i>(entrer jusqu'à quatre adversaires dans les boîtes de recherche)</i><br/></span>
	  		</div>
			</div>
			<br/>

    	<div className="row">
				<div className="col-md-3">
					<AutoSuggestPlayer playerId={this.state.opponentsIds[0]} dataChange={this.handlePlayerChange1} 
						onBlur={this.handlePlayerOnBlur1}/><br/>
    		</div>
				<div className="col-md-3">
					<AutoSuggestPlayer playerId={this.state.opponentsIds[1]} dataChange={this.handlePlayerChange2} 
						onBlur={this.handlePlayerOnBlur2}/><br/>
    		</div>
    		</div>
      	<div className="row">
				<div className="col-md-3">
					<AutoSuggestPlayer playerId={this.state.opponentsIds[2]} dataChange={this.handlePlayerChange3} 
						onBlur={this.handlePlayerOnBlur3}/><br/>
    		</div>
				<div className="col-md-3">
					<AutoSuggestPlayer playerId={this.state.opponentsIds[3]} dataChange={this.handlePlayerChange4} 
						onBlur={this.handlePlayerOnBlur4}/><br/>
    		</div>
  			</div>

				<div className="table-responsive">
				<table className="table table-striped table-hover table-sm">
				<thead>
					<tr>
					<th id="colid.0" className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable2} width={nameCellWidthPx}> Joueur(s) </th>
					<th id="colid.1" className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable2} width={nameCellWidthPx}> Adversaire(s) </th>
					<th id="colid.2" className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable2}> PJ </th>
					<th id="colid.3" className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable2}> VIC </th>
					<th id="colid.4" className={"statelo-sorting " + sortClass[4]} onClick={this.handleSortTable2}> DEF </th>
					<th id="colid.5" className={"statelo-sorting " + sortClass[5]} onClick={this.handleSortTable2}> EP </th>
					<th id="colid.6" className={"statelo-sorting " + sortClass[6]} onClick={this.handleSortTable2}> EC </th>
					{this.state.showTVs ? <th id="colid.7" className={"statelo-sorting " + sortClass[7]} onClick={this.handleSortTable2}> TVP </th> : null}
					{this.state.showTVs ? <th id="colid.8" className={"statelo-sorting " + sortClass[8]} onClick={this.handleSortTable2}> TVC </th> : null}
					<th id="colid.9" className={"statelo-sorting " + sortClass[9]} onClick={this.handleSortTable2}> % VIC </th>
					</tr>
				</thead>

				<tbody>
					{(this.state.resultTableData2.length > 0) ? 
						this.state.resultTableData2.map(this.createTableRow2) :
						this.dispNoResults()
					}
				</tbody>
				</table>

				</div>
			</div>
		);
	}

	displayPagination(pager) {
		return (
      <ul className="pagination">
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(1)}>{"<<"}</a>
        </li>
        <li className={pager.currentPage === 1 ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage - 1)}>{"<"}</a>
        </li>
        {pager.pages.map((page, index) =>
          <li key={index} className={pager.currentPage === page ? 'active' : ''}>
            <a onClick={() => this.setPage(page)}>{page}</a>
          </li>
        )}
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.currentPage + 1)}>{">"}</a>
        </li>
        <li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
          <a onClick={() => this.setPage(pager.totalPages)}>{">>"}</a>
        </li>
      </ul>
		);
	}

	createTableRow1(item, idx) {
		return (
			<tr key={'te.' + idx}>
				<td>{item.player1name}</td>
				<td>{item.player2name}</td>
				<td>{item.gamesPlayed}</td>
				<td>{item.wins}</td>
				<td>{item.losts}</td>
				<td>{item.nbEroPour}</td>
				<td>{item.nbEroContre}</td>
				{this.state.showTVs ? <td>{item.nbTvPour}</td> : null}
				{this.state.showTVs ? <td>{item.nbTvContre}</td> : null}
{/*
				columns for 9 ball leagues

				<td>{item.player1Score}</td>
				<td>{item.player2Score}</td>
				<td>{item.player1Score}</td>
				<td>{item.player2Score}</td>
*/}
				<td>{item.winPct.toFixed(1)}</td>
      </tr>
    );
	}

	createTableRow2(dataRow, idx) {
		return (
			<tr key={'te.' + idx}>
				{dataRow.map(this.createTableCell2)}
      </tr>
    );
	}

	createTableCell2(cell, idx) {
		// WinPct
		if (idx === 9) {
			cell = cell.toFixed(1);
		}

		if ((!this.state.showTVs) && ((idx === 7) || (idx === 8))) {
			return;
		}

		return (
			<td key={'td.' + idx}> {cell} </td>
		);
	}

	dispNoResults() {
		return (
			<tr><td colSpan="99"><p>Aucun résultat</p></td></tr>
		)
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable1(e) {
		// Sort data from database in api request
		var _this = this;
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var results = this.state.resultTableData1;
		var sortOrder = this.state.sortOrder1;
		var sortFieldIdx = this.state.sortFieldIdx1;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			if (colIdx === 1) {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		}

		var sortClass = [];
		for(var i = 0; i < (DASHMOD_NBOF_DATACOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		this.setState({
			sortOrder1: sortOrder,
			sortFieldIdx1: colIdx,
			sortClass1: sortClass
		});

		this.loadData1(this.state.pager, colIdx, sortOrder);
	}

	handleSortTable2(e) {
		// Sort data in front end
		var _this = this;
		var colIdx = parseInt(e.target.id.split(".")[1], 10);

		var sortOrder = this.state.sortOrder2;
		var sortFieldIdx = this.state.sortFieldIdx2;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			if (colIdx === 1) {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		}

		var sortClass = [];
		for(var i = 0; i < (DASHMOD_NBOF_DATACOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

    this.sortData2(this.state.resultTableData2, colIdx, sortOrder, sortClass);
	}

	handleMinGamesPlayed(e) {
		this.setState({minGamesPlayed : e.target.value})
	}
	handleApplyFilter() {
		var minGamesPlayed = this.state.minGamesPlayed;
		if (minGamesPlayed < 1) {minGamesPlayed = 1}
		this.setState({filtLoading: true});
		this.initiatePagerSizeWithData(this.state.playerId, this.state.resultsType, this.state.leagueType, minGamesPlayed, false);
	}
	handleRemoveFilter() {
		this.setState({filtLoading: true});
		this.initiatePagerSizeWithData(this.state.playerId, this.state.resultsType, this.state.leagueType, 1, false);
	}

	handlePlayerChange1(opponentId) {
		this.loadData2(0, opponentId, this.state.playerId, this.state.resultsType, this.state.leagueType);
	}
	handlePlayerChange2(opponentId) {
		this.loadData2(1, opponentId, this.state.playerId, this.state.resultsType, this.state.leagueType);
	}
	handlePlayerChange3(opponentId) {
		this.loadData2(2, opponentId, this.state.playerId, this.state.resultsType, this.state.leagueType);
	}
	handlePlayerChange4(opponentId) {
		this.loadData2(3, opponentId, this.state.playerId, this.state.resultsType, this.state.leagueType);
	}

	handlePlayerOnBlur1(opponentId) {
		if (opponentId === '') {
			this.loadData2(0, '0', this.state.playerId, this.state.resultsType, this.state.leagueType);
		}
	}
	handlePlayerOnBlur2(opponentId) {
		if (opponentId === '') {
			this.loadData2(1, '0', this.state.playerId, this.state.resultsType, this.state.leagueType);
		}
	}
	handlePlayerOnBlur3(opponentId) {
		if (opponentId === '') {
			this.loadData2(2, '0', this.state.playerId, this.state.resultsType, this.state.leagueType);
		}
	}
	handlePlayerOnBlur4(opponentId) {
		if (opponentId === '') {
			this.loadData2(3, '0', this.state.playerId, this.state.resultsType, this.state.leagueType);
		}
	}

}

export default DashMod_GameResultsPlayerComp01;
